export const SIDEBAR_OPEN_STATE_KEY = 'sidebar_open_state';
export const CURRENT_WELL = 'currentWell';
export const KICK_DETECTION_DISMISSED_WELLS = 'kickDetectionDismissedWells';
export const ANTI_COLLISION_DISMISSED_WELLS = 'antiCollisionDismissedWells';
export const WELL_HOME_PLOT_CONFIG = 'wellHomePlotConfig';
export const WELL_HOME_DASHBOARD_CONFIG = 'wellHomeDashboardConfig';
export const ONBOARDING = {
  WELL_HOME: 'shouldDisplayWellHomeOnboarding',
  EDDR_OVERVIEW: 'shouldDisplayEddrOverviewOnboarding',
};
export const HAS_ACTIVATED_BETA_FEATURES = 'hasActivatedBetaFeatures';
export const HIDDEN_WEB_INCIDENTS = 'hiddenWebIncidents';

export type KickDetectionDismissedWellsInStorage = { [wellboreId: string]: string };
export type AntiCollisionDismissedWellsInStorage = { [wellboreId: string]: number };

export default class LocalStorer {
  static set(key: string, data: string): void {
    localStorage.setItem(key, data);
  }

  static get(key: string): string | null {
    return localStorage.getItem(key);
  }
}
